import { useStorage } from "@vueuse/core";
import { computed } from "vue";

interface SortState {
  sortField: string;
  sortDir: string;
  opinionStatus: string[];
}

export const useSortStore = defineStore("sort", () => {
  const storage = useStorage<SortState>("digiform:sort", {
    sortField: "first_name",
    sortDir: "asc",
    opinionStatus: [],
  });

  const sortField = computed(() => storage.value.sortField);
  const sortDir = computed(() => storage.value.sortDir);
  const opinionStatus = computed(() => storage.value.opinionStatus);
  const getState = computed(() => storage.value);

  function setSortField(field: string) {
    storage.value.sortField = field;
  }
  function setSortDir(dir: string) {
    storage.value.sortDir = dir;
  }
  function setOpinionStatus(status: string[]) {
    storage.value.opinionStatus = status;
  }

  return { sortField, sortDir, opinionStatus, getState, setSortField, setSortDir, setOpinionStatus };
});
